import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TaskPreference } from '@demind-inc/core';

import { tasksApi } from '../api';

interface UseUpdateTaskPrefParams {
  preferenceId: string;
  preferences: Partial<TaskPreference>;
}

export const useUpdateTaskPref = () => {
  const queryClient = useQueryClient();

  const updateTaskPrefMutation = useMutation({
    mutationFn: ({ preferenceId, preferences }: UseUpdateTaskPrefParams) => {
      return tasksApi.updateTaskPreference(preferenceId, preferences).then((data) => data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.preference'] });
    },
  });

  return {
    updateTaskPref: updateTaskPrefMutation.mutateAsync,
    ...updateTaskPrefMutation,
  };
};